import React from "react";
import Logo from "../../Components/GeneralComponents/Logo";
import AccountMenu from "../../Components/GeneralComponents/AccountMenu";
import { useContent } from "../../hooks/useContent";
import { NavLink } from "react-router-dom";
import Breadcrumbs from "../../Components/GeneralComponents/Breadcrumbs";

export default function AppHeader() {
  const { pageHeading } = useContent();

  return (
    <header className="header shadow-sm">
      <div className="container py-3">
        <div className="d-flex justify-content-between align-items-center header-content">
          <NavLink to="/" className="text-decoration-none logo-link">
            <Logo />
          </NavLink>
          <div className="text-center flex-fill header-center">
            <h2 className="mb-0 fw-bold">{pageHeading}</h2>
            <Breadcrumbs />
          </div>
          <div className="d-flex justify-content-end align-items-center header-right">
            <AccountMenu />
          </div>
        </div>
      </div>
    </header>
  );
}
